// src/context/NotificationsContext.jsx
import React, {
  createContext,
  useContext,
  useState,
  useMemo,
} from "react";
import { enhancedNotifications as initialNotifications } from "../../data/Notificaciones";

const NotificationsContext = createContext(null);

export function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState(initialNotifications);

  const markAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id
          ? { ...notif, isUnread: false, highlight: false }
          : notif
      )
    );
  };

  const markAllAsRead = () => {
    setNotifications((prev) =>
      prev.map((notif) => ({ ...notif, isUnread: false, highlight: false }))
    );
  };

  const unreadCount = useMemo(
    () => notifications.filter((n) => n.isUnread).length,
    [notifications]
  );

  const value = {
    notifications,
    markAsRead,
    markAllAsRead,
    unreadCount,
  };

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error(
      "useNotifications debe usarse dentro de NotificationsProvider"
    );
  }
  return ctx;
}
